// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "div.botaoMenuItem > span{\n    font-size: 0.9rem;        \n}\n\nspan.menuItemPai > div.botaoMenuItem > span {\n    font-weight: 700;\n}\n\nspan.subMenuItemPai > div.botaoMenuItem > span {\n    font-weight: 700;\n}\n\nspan.subMenuItemPai > div.botaoMenuItem {\n    margin-left: 2px;\n}", ""]);
// Exports
module.exports = exports;
